module.exports = __webpack_public_path__ + "img/erajaya.e224b6d6.png";